import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import compose from 'lodash/fp/compose';
import { Stars } from '@catalogo/theme-stars';
import Like from '@catalogo/ui-americanas-desktop-svg/like-v2.svg';
import withReviewFeedback from '@catalogo/service-americanas-product-review/src/legacy/hocs/withReviewFeedback';
import { withConfig } from '@catalogo/core-connect/config';
import CollapseText from '@catalogo/theme-collapse-text';

const MAX_REVIEW_LENGTH = 340;

const formatDate = date => new Date(date).toLocaleDateString('pt-BR');

export const Review = ({
  title,
  rating,
  review,
  date,
  user,
  authorId,
  isVerifiedPurchaser,
  id,
  handleClick,
  feedback,
  config,
}) => (
  <Wrapper>
    <WrapperReview>
      <Title>{title}</Title>
      <WrapperStarAndDate>
        <Stars rating={rating} size={22} />
      </WrapperStarAndDate>
      <CollapseText text={review} maxTextLength={MAX_REVIEW_LENGTH} defaultTextHeight={74} />
      <User>
        {user === authorId ? `Cliente (${config.shortName})` : user} em {formatDate(date)}
        {isVerifiedPurchaser && <VerifiedPurchaser>comprei e avaliei</VerifiedPurchaser>}
      </User>
    </WrapperReview>
    <WrapperRecomendation>
      <RecomendationText>esta avaliação foi útil ?</RecomendationText>
      <Flex>
        <ActionRecommentation onClick={() => handleClick({ Vote: 'Positive', id })}>
          <LikeUI $userfeedback={feedback.like}>
            <Like />
          </LikeUI>
          <LabelRecommentation>({feedback.likeCount})</LabelRecommentation>
        </ActionRecommentation>
        <ActionRecommentation onClick={() => handleClick({ Vote: 'Negative', id })}>
          <Unlike $userfeedback={feedback.dislike}>
            <Like />
          </Unlike>
          <LabelRecommentation>({feedback.dislikeCount})</LabelRecommentation>
        </ActionRecommentation>
      </Flex>
    </WrapperRecomendation>
  </Wrapper>
);

Review.propTypes = {
  title: PropTypes.string,
  rating: PropTypes.number,
  review: PropTypes.string,
  date: PropTypes.string,
  user: PropTypes.string,
  isVerifiedPurchaser: PropTypes.bool,
  id: PropTypes.number,
  sendFeedback: PropTypes.func,
  vote: PropTypes.string,
  feedback: PropTypes.object,
};

export default compose(withReviewFeedback, withConfig)(Review);

const Flex = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const Wrapper = styled(Flex)`
  align-items: stretch;
  padding-top: 30px;
  margin: 0 16px 20px 16px;
  padding: 26px 29px;
  background: #f8f8f8;
`;

const WrapperReview = styled.div`
  width: 75%;
`;

const Title = styled.h4`
  font-weight: bold;
  margin-bottom: 1.3rem;
  color: ${({ theme }) => theme.grey.dark};
  font-size: ${({ theme }) => theme.fontSize.md};
`;

const WrapperStarAndDate = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1.3rem;
  color: ${({ theme }) => theme.grey.dark};
  font-size: ${({ theme }) => theme.fontSize.xs};
`;

const User = styled(Flex)`
  color: #838383;
  font-size: ${({ theme }) => theme.fontSize.xs};
  justify-content: flex-start;
  margin: 1.5rem 0;
  font-weight: 700;
  font-size: 15px;
`;

const WrapperRecomendation = styled(Flex)`
  margin-left: 30px;
  color: ${({ theme }) => theme.grey.dark};
  font-size: 16px;
  font-weight: bold;
  flex-direction: column;
  width: 25%;
  border-left: 1px solid ${({ theme }) => theme.grey.light};
`;

const LikeUI = styled.div`
  width: 26px;
  stroke: ${({ theme, $userfeedback }) => ($userfeedback ? theme.buttonLikeColor : theme.grey.dark)};
`;
const Unlike = styled(LikeUI)`
  transform: rotate(180deg);
  stroke: ${({ theme, $userfeedback }) => ($userfeedback ? theme.buttonDislikeColor : theme.grey.dark)};
`;

const ActionRecommentation = styled.button`
  display: flex;
  background: transparent;
  border: 0;
  padding: 0px 10px;
  align-items: center;
  outline: none;
  cursor: pointer;
`;

const LabelRecommentation = styled.span`
  color: ${({ theme }) => theme.grey.dark};
  margin-left: 8px;
  font-size: ${({ theme }) => theme.fontSize.xs};
`;

const RecomendationText = styled.span`
  padding-bottom: 10px;
  font-size: ${({ theme }) => theme.fontSize.lg};
`;

const VerifiedPurchaser = styled.div`
  width: max-content;
  border-radius: 8px;
  background: #dcedc9;
  color: ${({ theme }) => theme.grey.dark};
  padding: 5px 15px;
  font-size: 14px;
  margin-left: 15px;
  font-weight: normal;
  display: flex;
  justify-content: center;

  &::before {
    content: '';
    margin-right: 8px;
    width: 5px;
    height: 10px;
    border: solid ${({ theme }) => theme.grey.dark};
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
`;
